import s from "@/app/[locale]/common/components/Breadcrumbs/Breadcrumbs.module.scss";
import {Link} from '@/i18n/routing';
import {TCrumbProps} from "@/app/[locale]/common/components/Breadcrumbs/types";
import {GLOBAL_LABELS} from "../../constants/app";

export const Crumb = ({ title, href, active }: TCrumbProps) => {
    return (
        <div className={`${s.crumb}`}>
            {
                title !== GLOBAL_LABELS.HOME &&
                <span className={`${s.crumb_default} ${active ? s.crumb_active : ''}`}>/</span>
            }
            <Link
                href={href}
                className={`${s.crumb_default} ${active ? s.crumb_active : ''}`}
            >
                {title}
            </Link>
        </div>
    );
};